var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshFilled = function SvgRefreshFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.659 6.345a8 8 0 1 0 2.029 7.878 1 1 0 0 1 1.921.554C20.406 18.948 16.561 22 12 22 6.477 22 2 17.523 2 12S6.477 2 12 2a9.97 9.97 0 0 1 7.074 2.931c.636.637 1.32 1.427 1.926 2.163V4a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1h-6a1 1 0 1 1 0-2h3.97c-.685-.859-1.547-1.89-2.311-2.655"
  })));
};
export default SvgRefreshFilled;